<button type="button" mcIconHighlight [color]="color" [matMenuTriggerFor]="helpMenu" [matMenuTriggerRestoreFocus]="false">
  <mat-icon class="mc-image-icon" fontSet="project-titan" fontIcon="icon-circle-help"></mat-icon>
</button>

<mat-menu #helpMenu="matMenu" [overlapTrigger]="false" class="mc-help-icon-button-menu" [class]="helpMenuClass">
  <ng-content></ng-content>
</mat-menu>